"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 14.421c-.286 1.378-1.557 4.915-5.611 6.83l-1.628-1.832-2.747 2.762a10.139 10.139 0 0 1-8.018-4.113c.292.091.593.148.898.17.45.008.937-.157.937-.913V9.873a1.23 1.23 0 0 0-1.543-1.23C3.016 8.936 2 12.11 2 12.11a10.09 10.09 0 0 1 3.493-7.733A10.235 10.235 0 0 1 10.646 2c-1.39.791-2.17 2.082-2.17 3.164 0 1.743 1.05 1.532 1.36 1.275v10.058a1.6 1.6 0 0 0 .206.354 1.485 1.485 0 0 0 1.215.615c1.05 0 2.414-1.2 2.414-1.2v-8.14c0-.829-.625-1.829-1.25-2.172 0 0 1.157-.205 2.05.478.168-.205.346-.4.534-.587 2.084-2.045 4.047-2.627 5.682-2.918 0 0-2.973 2.336-2.973 5.47 0 2.331.06 8.016.06 8.016 1.104 1.065 2.744-.473 4.226-1.992z" }), "Unreal");
//# sourceMappingURL=Unreal.js.map